// features/contact/contact.service.ts
import { post } from '../../api/api.service';

export interface ContactFormPayload {
  name: string;
  email: string;
  phoneNumber: string;
  message: string;
  subject: string;
}

export const submitContactFormApi = async (payload: ContactFormPayload) => {
  try {
    const response = await post<any>('/contactus', payload);
    return response;
  } catch (error) {
    throw error;
  }
};
